import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const NotFoundRoute = LazyLoad(
  lazy(() => import('./not-found').then((module) => ({ default: module.NotFound }))),
);
